import React, { useEffect, useState } from 'react';
import { Panel } from 'rsuite';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  getFetched,
  getAll as getGuestNotes
} from '../../../../redux/Guest/selectors/note';
import { fetchGuestNotes } from '../../../../redux/sagas/routines';
import NoteForm from '../../../../components/guest/NoteForm';
import NotesList from '../../../../components/guest/NotesList';

const NotesSection = ({ guestId, ...props }) => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);

  const [noteToEdit, setNoteToEdit] = useState(null);
  const notes = useSelector(getGuestNotes);
  const isFetched = useSelector(getFetched);

  useEffect(
    () => {
      if (!guestId || isFetched) return;
      dispatch(fetchGuestNotes({ guestId }));
    },
    [guestId]
  );

  useEffect(
    () => {
      if (noteToEdit) {
        setShowForm(true);
      }
    },
    [noteToEdit]
  );

  const handleOnEdit = note => {
    setNoteToEdit(note);
    window.scrollTo(0, 0);
  };

  const handleHideForm = () => {
    setShowForm(false);
    setNoteToEdit(null);
  };

  const handleShowForm = () => {
    setShowForm(true);
  };

  return (
    <Panel {...props}>
      <NoteForm
        guestId={guestId}
        data={noteToEdit}
        showForm={showForm}
        onHideForm={handleHideForm}
        onShowForm={handleShowForm}
      />
      <NotesList guestId={guestId} data={notes} onEdit={handleOnEdit} />
    </Panel>
  );
};

NotesSection.propTypes = {
  guestId: PropTypes.number.isRequired
};

export default NotesSection;
